import ActionTypes from "./actionTypes";

export const addActivePanel = (panel: string) => {
	return { type: ActionTypes.ACTIVE_PANEL_ADD, panel};
};

export const removeActivePanel = (panel: string, params: object) => {
	return { type: ActionTypes.ACTIVE_PANEL_REMOVE, panel};
};

export const addActiveView = (viewId: string, viewKey: string, panelInstance: string) => {
	return { type: ActionTypes.ACTIVE_VIEW_ADD, viewId, viewKey, panelInstance};
};

export const removeActiveView = (view: string, panelInstance: string) => {
	return { type: ActionTypes.ACTIVE_VIEW_REMOVE, view};
};

export const setGlobalState = (panelInstance: string, state: {}) => {
	return { type: ActionTypes.SET_GLOBAL_PANEL_STATE, panelInstance, state };
}



// WEBPACK FOOTER //
// ./src/core/actions/activeActions.ts